




import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class ObfuscatedEmail extends Vue {
  @Prop(String) readonly email: string | undefined;

  get reversedEmail() {
    return this.email!!.split('').reverse().join('');
  }
}
